import { useState } from "react";
import * as authApi from "../api/auth";
import { recoverProblem } from "../auth-validation";
import { Dialog, MessageBox } from "../ui/Dialog";
import { PasswordInput } from "../ui/PasswordInput";

/** recover_password_dialog.py. A shared (non-SQLite) server refuses this with its own explanation, shown as is. */
export function RecoverPasswordDialog({ onClose, onReset }: { onClose: () => void; onReset: (username: string) => void }) {
  const [username, setUsername] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async () => {
    const problem = recoverProblem(username, next, confirm);
    if (problem) { setError(problem); return; }
    setBusy(true);
    try {
      await authApi.recoverPassword(username.trim(), next);
      setDone(true);
    } catch (e) {
      setError((e as Error).message);
    } finally { setBusy(false); }
  };

  if (done) {
    return <MessageBox title="Password Reset"
      text={`The password for “${username.trim()}” has been changed.\n\nYou can sign in with it now.`}
      onClose={() => { onReset(username.trim()); onClose(); }} />;
  }
  return (
    <Dialog title="Reset Password" onClose={onClose} testId="recover-password">
      <p className="muted" style={{ whiteSpace: "pre-line", marginTop: 0 }}>
        {"Set a new password for an account on this computer.\n\nYour projects, images and annotations are not affected — only the password changes."}
      </p>
      <div className="form-row"><label htmlFor="rp-user">Username / Email</label>
        <input id="rp-user" className="input" placeholder="Username or email" value={username} onChange={(e) => setUsername(e.target.value)} /></div>
      <div className="form-row"><label htmlFor="rp-new">New password</label><PasswordInput id="rp-new" value={next} onChange={setNext} autoComplete="new-password" /></div>
      <div className="form-row"><label htmlFor="rp-conf">Confirm password</label><PasswordInput id="rp-conf" value={confirm} onChange={setConfirm} onEnter={submit} autoComplete="new-password" /></div>
      <div className="error-text" role="alert" data-testid="rp-error">{error}</div>
      <div className="dialog-actions">
        <button className="btn" onClick={onClose}>Cancel</button>
        <button className="btn primary" disabled={busy} onClick={submit}>Set Password</button>
      </div>
    </Dialog>
  );
}
